/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { useConfig } from '../config-provider/useConfig.js';
import '@vue/composition-api';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

function useCommonClassName() {
  var _useConfig = useConfig(),
      classPrefix = _useConfig.classPrefix;

  var sizeClassNames = {
    small: "".concat(classPrefix.value, "-size-s"),
    medium: "".concat(classPrefix.value, "-size-m"),
    large: "".concat(classPrefix.value, "-size-l"),
    "default": "",
    xs: "".concat(classPrefix.value, "-size-xs"),
    xl: "".concat(classPrefix.value, "-size-xl"),
    block: "".concat(classPrefix.value, "-size-full-width")
  };
  var statusClassNames = {
    loading: "".concat(classPrefix.value, "-is-loading"),
    loadMore: "".concat(classPrefix.value, "-is-load-more"),
    disabled: "".concat(classPrefix.value, "-is-disabled"),
    focused: "".concat(classPrefix.value, "-is-focused"),
    success: "".concat(classPrefix.value, "-is-success"),
    error: "".concat(classPrefix.value, "-is-error"),
    warning: "".concat(classPrefix.value, "-is-warning"),
    selected: "".concat(classPrefix.value, "-is-selected"),
    active: "".concat(classPrefix.value, "-is-active"),
    checked: "".concat(classPrefix.value, "-is-checked"),
    current: "".concat(classPrefix.value, "-is-current"),
    hidden: "".concat(classPrefix.value, "-is-hidden"),
    visible: "".concat(classPrefix.value, "-is-visible"),
    expanded: "".concat(classPrefix.value, "-is-expanded"),
    indeterminate: "".concat(classPrefix.value, "-is-indeterminate")
  };
  return {
    classPrefix: classPrefix,
    sizeClassNames: sizeClassNames,
    statusClassNames: statusClassNames,
    classNames: {
      size: sizeClassNames,
      status: statusClassNames
    }
  };
}

export { useCommonClassName as default };
//# sourceMappingURL=useCommonClassName.js.map
